module.exports = __webpack_public_path__ + "img/leopard.d73ed219.png";